import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';

// Import componenti
import Home from './componentPublic/home';
import NotFound from './component/specimen/notFound';
import Footer from "./component/layout/Footer";
import Navbar from "./component/layout/Navbar";
import Spinner from "./component/layout/Spinner"; // Potrebbe non servire più, ma lo lasciamo
import { properties } from "./config/properties";
import {Container} from "design-react-kit"; // Potrebbe non servire più, ma lo lasciamo

// Import componenti di routing (da index.js originale)
import Dashboard from './component/specimen/dashboard';
import RicercaSpecimen from "./component/specimen/cerca/ricercaSpecimen";
import ElencoSpecimenRicercati from "./component/specimen/cerca/elencoSpecimenRicercati";
import ElencoRuoli from "./component/specimen/ruoli/elencoRuoli";
import ElencoAreeCompetenza from "./component/specimen/areeCompetenza/elencoAreeCompetenza";
import ElencoDeleghe from "./component/specimen/deleghe/elencoDeleghe";
import InserimentoRuolo from "./component/specimen/ruoli/inserimentoRuolo";
import InserimentoAreaCompetenza from "./component/specimen/areeCompetenza/inserimentoAreaCompetenza";
import InserimentoDelega from "./component/specimen/deleghe/inserimentoDelega";
import OrdinamentoRuoli from "./component/specimen/ruoli/odinamentoRuoli";
import OrdinamentoAreeCompetenza from "./component/specimen/areeCompetenza/ordinamentoAreeCompetenza";
import ProfiloSpecimen from "./component/specimen/cerca/profiloSpecimen";
import ListaSpecimen from "./component/specimen/cerca/listaSpecimen";
import RicercaListaSpecimen from "./component/specimen/cerca/ricercaListaSpecimen";
import ElencoPersone from "./component/specimen/persone/elencoPersone";
import RicercaPersone from "./component/specimen/persone/ricercaPersone";
import InserimentoPersona from "./component/specimen/persone/inserimentoPersona";
import Pubblica from "./component/specimen/pubblica";
import ModificaPersona from "./component/specimen/persone/modificaPersona";
import GestioneDeleghePersona from "./component/specimen/persone/gestioneDeleghePersona";
import InserimentoDeleghePersona from "./component/specimen/persone/inserimentoDeleghePersona";
import ModificaDelegaPersona from "./component/specimen/persone/modificaDelegaPersona";
import ProfiloPersona from "./component/specimen/persone/profiloPersona";
import GestioneFirma from "./component/specimen/persone/gestioneFirma";
import InviaMail from "./component/specimen/documentazione/inviaMail";
import ElencoDestinatariMail from "./component/specimen/documentazione/elencoDestinatariMail";
import InserimentoDestinatarioMail from "./component/specimen/documentazione/inserimentoDestinatarioMail";
import ListaSpecimenDocumentazione from "./component/specimen/documentazione/listaSpecimenCameraUser";


// Funzione makeHttpCall (copiata da index - Copia.js)
function makeHttpCall(url){
    let response = {};
    try{
        const request = new XMLHttpRequest();
        request.open('GET',url, false);  // `false` rende la richiesta sincrona
        request.send(null);

        response = request.response

        response= JSON.parse(response)


    }catch(e){
        // console.error("Errore nella chiamata HTTP sincrona:", e);
        response= {}

    }
    return response
}

// Chiamata sincrona per ottenere l'utente (simulando la logica di index - Copia.js)
// Nel file originale il path era: `${properties.fullBaseUrl}${properties.baseAppUrl}/user/service/getEacoUser`
// Se usassimo il path di index - Copia.js: `${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/user/logged`
// Per coerenza con il primo file, assumiamo che il servizio da chiamare sia lo stesso, ma sincrono.
// Se la risposta è come nel primo file (con json.utente), la mappiamo.

let userResponse = makeHttpCall(properties.fullBaseUrl + properties.baseAppUrl + "/user/service/getEacoUser");
let user = {};

if (userResponse.esito === 'OK' && userResponse.utente) {
    user = {
        // Mappiamo le proprietà di json.utente a user come nel vecchio useEffect
        userID: userResponse.utente.userID,
        cciaa: userResponse.utente.cciaa,
        cciaas: userResponse.utente.cciaas,
        gruppoUtente: userResponse.utente.gruppoUtente // Usiamo 'gruppoUtente' per il routing
    };
}

const AppContent = () => {

    // Non ci sono più useState/useEffect per l'utente,
    // user viene letto direttamente dalla variabile 'user' globale.

    // Nel file originale c'era un check sul 401 che reindirizzava
    // Sostituiamo il reindirizzamento 401 con un controllo se l'utente è nullo
    // e non è su una path pubblica. Tuttavia, con la chiamata sincrona,
    // se non otteniamo l'utente, trattiamo l'utente come disconnesso (user === null).

    return (

        <div>
            {/* Passiamo l'utente letto sincronicamente alla Navbar */}
            {/* Rimuoviamo setUser perché non gestiamo più lo stato locale */}
            <Navbar user={user} />

            {/* rotte */}
            <div className={"mainContainerViewCustom"}>

                {/* Controllo per gruppoUtente "SPCFBASE" */}
                {user != null && user.gruppoUtente === "SPCFBASE" ?

                    <Routes>
                        {/* SEZIONE CERCA */}
                        <Route path="/public/homepage" element={<Home user={user} />}/>
                        <Route path="/public/notfound" element={<NotFound/>}/>
                        <Route path="/private/dashboard" element={<Dashboard user={user} />}/>
                        <Route path="/private/ricercaSpecimen" element={<RicercaSpecimen/>}/>
                        <Route path="/private/elencoSpecimenRicercati" element={<ElencoSpecimenRicercati user={user} />}/>
                        <Route path="/private/profiloSpecimen" element={<ProfiloSpecimen user={user} />}/>
                        <Route path="/private/ricercaListaSpecimen" element={<RicercaListaSpecimen/>}/>
                        <Route path="/private/listaSpecimen" element={<ListaSpecimen user={user} />}/>


                        {/* SEZIONE PERSONE */}
                        <Route path="/private/elencoPersone" element={<ElencoPersone user={user}/>}/>
                        <Route path="/private/profiloPersona" element={<ProfiloPersona user={user}/>}/>
                        <Route path="/private/modificaPersona" element={<ModificaPersona user={user} />}/>
                        <Route path="/private/gestioneFirma" element={<GestioneFirma user={user} />}/>
                        <Route path="/private/gestioneDeleghePersona" element={<GestioneDeleghePersona user={user} />}/>
                        <Route path="/private/inserimentoDeleghePersona" element={<InserimentoDeleghePersona user={user}/>}/>
                        <Route path="/private/modificaDelegaPersona" element={<ModificaDelegaPersona user={user}/>}/>
                        <Route path="/private/ricercaPersone" element={<RicercaPersone user={user} />}/>
                        <Route path="/private/inserimentoPersona" element={<InserimentoPersona user={user}/>}/>


                        {/* SEZIONE RUOLI*/}
                        <Route path="/private/elencoRuoli" element={<ElencoRuoli user={user} />}/>
                        <Route path="/private/inserimentoRuolo" element={<InserimentoRuolo user={user}/>}/>
                        <Route path="/private/ordinamentoRuoli" element={<OrdinamentoRuoli user={user} />}/>


                        {/* SEZIONE AREE*/}
                        <Route path="/private/elencoAreeCompetenza" element={<ElencoAreeCompetenza user={user} />}/>
                        <Route path="/private/inserimentoAreaCompetenza"
                               element={<InserimentoAreaCompetenza user={user}/>}/>
                        <Route path="/private/ordinamentoAreeCompetenza"
                               element={<OrdinamentoAreeCompetenza user={user} />}/>


                        {/* SEZIONE DELEGHE*/}
                        <Route path="/private/elencoDeleghe" element={<ElencoDeleghe user={user} />}/>
                        <Route path="/private/inserimentoDelega" element={<InserimentoDelega user={user}  />}/>


                        {/* SEZIONE PUBBLICA*/}
                        <Route path="/private/pubblica" element={<Pubblica user={user} />}/>


                        {/* SEZIONE DOCUMENTAZIONE*/}
                        <Route path="/private/listaSpecimenCameraUser"
                               element={<ListaSpecimenDocumentazione user={user} />}/>
                        <Route path="/private/inviaMail" element={<InviaMail user={user}/>}/>
                        <Route path="/private/elencoDestinatariMail" element={<ElencoDestinatariMail user={user} />}/>
                        <Route path="/private/inserimentoDestinatarioMail"
                               element={<InserimentoDestinatarioMail user={user} />}/>


                        {/* Url di redirect: Se tenta di accedere a URL non mappati, reindirizza alla dashboard o homepage */}
                        <Route path="*" element={<Navigate to="/private/dashboard" replace/>}/>


                    </Routes>

                    :

                    /* Controllo per gruppoUtente "SPCFENTE" */
                    user != null && user.gruppoUtente === "SPCFENTE" ?

                        <Routes>

                            {/* SEZIONE CERCA */}
                            <Route path="/public/homepage" element={<Home user={user} />}/>
                            <Route path="/public/notfound" element={<NotFound/>}/>
                            <Route path="/private/dashboard" element={<Dashboard user={user} />}/>
                            <Route path="/private/ricercaSpecimen" element={<RicercaSpecimen/>}/>
                            <Route path="/private/elencoSpecimenRicercati" element={<ElencoSpecimenRicercati user={user} />}/>
                            <Route path="/private/profiloSpecimen" element={<ProfiloSpecimen user={user} />}/>
                            <Route path="/private/ricercaListaSpecimen" element={<RicercaListaSpecimen/>}/>
                            <Route path="/private/listaSpecimen" element={<ListaSpecimen user={user} />}/>

                            {/* Url di redirect: Se tenta di accedere a URL non mappati, reindirizza alla dashboard o homepage */}
                            <Route path="*" element={<Navigate to="/private/dashboard" replace/>}/>

                        </Routes>

                        :

                        /* Utente non loggato (user === null o gruppo non riconosciuto) */
                        <Routes>

                            <Route path="/" element={<Home user={user} />}/>
                            <Route path="/public/homepage" element={<Home user={user} />}/>
                            <Route path="/public/notfound" element={<NotFound/>}/>

                            {/* Url di redirect: Qualsiasi altra pagina privata o non mappata reindirizza alla homepage (o login, se presente) */}
                            {/* Nel file originale non c'era una rotta di login per il caso base, quindi reindirizziamo a Home */}
                            <Route path="*" element={<Navigate to="/public/homepage" replace/>}/>


                        </Routes>


                }

            </div>
            <Footer/>
        </div>

    );
};

const App = () => (
    <BrowserRouter basename="/fspeWeb">
        <AppContent/>
    </BrowserRouter>
);


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);